import { Route } from 'react-router-dom';
import AuthGuard from '@/components/guards/AuthGuard';
import MainLayout from '@/layouts/MainLayout';
import Analytics from '@/pages/Analytics';
import AdminDashboard from '@/pages/AdminDashboard';
import { supabase } from '@/integrations/supabase/client';

// Check if user is in development/preview environment
const isDevelopment = () => {
  return window.location.hostname === 'localhost' || 
         window.location.hostname.includes('lovable.app');
};

// Check if user is admin
const isAdmin = async () => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return false;

    const { data } = await supabase
      .from('user_roles')
      .select('role')
      .eq('user_id', user.id)
      .eq('role', 'admin')
      .maybeSingle();

    return !!data;
  } catch {
    return false;
  }
};

// Protected routes that are only accessible in Lovable dashboard
export const protectedRoutes = [
  <Route 
    key="analytics" 
    path="/analytics" 
    element={
      <AuthGuard 
        isAuthenticated={isDevelopment}
        redirectTo="/"
        loadingComponent={
          <div className="min-h-screen flex items-center justify-center">
            <div className="text-center">
              <h1 className="text-2xl font-bold mb-2">401 Unauthorized</h1>
              <p className="text-muted-foreground">Diese Seite ist nicht öffentlich zugänglich.</p>
            </div>
          </div>
        }
      >
        <MainLayout>
          <Analytics />
        </MainLayout>
      </AuthGuard>
    } 
  />,
  <Route 
    key="admin" 
    path="/admin" 
    element={
      <AuthGuard 
        isAuthenticated={isAdmin}
        redirectTo="/"
        loadingComponent={
          <div className="min-h-screen flex items-center justify-center">
            <div className="text-center">
              <h1 className="text-2xl font-bold mb-2">401 Unauthorized</h1>
              <p className="text-muted-foreground">Nur für Administratoren zugänglich.</p>
            </div>
          </div>
        }
      >
        <MainLayout>
          <AdminDashboard />
        </MainLayout>
      </AuthGuard>
    } 
  />
];
